/* ------------------------------------------------------------------------------
@name: Utilities Index
@description: Indexing all utilities
--------------------------------------------------------------------------------- */

export { default as isOS } from '@utilities/isOS';
export { default as BrowserCheck } from '@utilities/BrowserCheck';
export { default as Scrolllable } from '@utilities/Scrolllable';
export { default as Validation } from '@utilities/Validation';
export { default as Session } from '@utilities/Session';
export { default as WindowResize } from '@utilities/WindowResize';
